
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29.287","height":"23.43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.921 19.285l-8.106-8.062 2.029-2.009 6.078 6.044 9.833-9.777A11.785 11.785 0 0011.782 0 11.748 11.748 0 00.001 11.715 11.748 11.748 0 0011.782 23.43a11.748 11.748 0 0011.781-11.715 11.647 11.647 0 00-.529-3.48l-11.113 11.05z","fill":"#f27c11"}}),_c('path',{attrs:{"d":"M29.287 2.017L27.266 0l-5.513 5.481a11.619 11.619 0 011.28 2.755l6.253-6.218z","fill":"#f27c11"}}),_c('path',{attrs:{"d":"M5.843 9.214l-2.029 2.009 8.106 8.062L23.033 8.234a11.615 11.615 0 00-1.28-2.754l-9.833 9.777-6.078-6.044z","fill":"#fdfdfd"}})])
          )
        }
      }
    